<template>
  <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
  <WdsPageSignup
    logo-link=""
    :nav-prev="showPrevButton"
    :nav-next="showNextButton"
    @prev="handlePreviousScreen"
    @next="handleNextScreen"
  >
    <template #prev-text>
      <span>{{ $t('Previous') }}</span>
    </template>

    <template #next-text>
      <span>{{ $t('Next') }}</span>
    </template>

    <template #left>
      <FlowHeading :title="title" :sub-title="subTitle" class="flow-heading" />

      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <WdsProgress
        :steps="steps"
        :current="currentStep"
        :most-completed-step="mostCompletedStep"
        @update-step="gotoStep"
      />
    </template>

    <template #left-footer>
      <WdsButtonText href="/logout">
        {{ $t('Log out') }}
      </WdsButtonText>
    </template>

    <template #right>
      <slot name="screen" />
    </template>
  </WdsPageSignup>
</template>

<script>
import gql from 'graphql-tag'
import { WdsButtonText } from '@worksome/wds-components'
import FlowHeading from '@/components/flows/FlowHeading.vue'
import FlowCoordinatePath from '@/utils/flows/FlowCoordinatePath'

export default {
  name: 'CompanySignupFlowLayout',

  components: {
    WdsButtonText,
    FlowHeading,
  },

  provide() {
    return {
      previous: this.handlePreviousScreen,
      next: this.handleNextScreen,
      skip: this.handleSkipScreen,
    }
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      steps: [],
      currentStep: [],
      mostCompletedStep: null,
      coordinates: {},
    }
  },

  computed: {
    showPrevButton() {
      return !!this.coordinates.previous
    },
    // conditions: if next url is valid and
    // if it is not the final step
    // if it is not current screen to prevent folks from jumping required screens JIRA-6568
    showNextButton() {
      let finalStep = this.steps[this.steps.length - 1]
      if (finalStep?.children?.length) {
        finalStep = finalStep.children[finalStep.children.length - 1]
      }
      const isFinalStep = finalStep?.url === this.coordinates?.current?.url

      const isCompletedStepAtLeastCurrent =
        FlowCoordinatePath.compare(this.mostCompletedStep, this.currentStep) >= 0

      return !!this.coordinates.next && !isFinalStep && isCompletedStepAtLeastCurrent
    },
  },

  methods: {
    handlePreviousScreen() {
      window.location = `${window.location.protocol}//${window.location.host}${this.coordinates.previous}`
    },
    handleNextScreen() {
      window.location = `${window.location.protocol}//${window.location.host}${this.coordinates.next}`
    },
    handleSkipScreen() {
      window.location = `${window.location.protocol}//${window.location.host}/dashboard?utm_nooverride=1'`
    },
    gotoStep(step) {
      window.location = step.url
    },
  },

  apollo: {
    getFlowCoordinates: {
      query: gql`
        query FlowCoordinates($path: String!) {
          flowCoordinate(input: { path: $path }) {
            previous
            current {
              path
              url
            }
            next
            mostCompletedStep
            navigation {
              name
              url
              isCurrent
              children {
                name
                url
                isCurrent
                children {
                  name
                  url
                  isCurrent
                }
              }
            }
          }
        }
      `,
      variables() {
        return {
          path: `${window.location.pathname}${window.location.search}`,
        }
      },
      result({ data }) {
        this.coordinates = data.flowCoordinate
        this.steps = data.flowCoordinate?.navigation?.children ?? []
        this.currentStep = data.flowCoordinate?.current.path ?? []

        this.mostCompletedStep = data.flowCoordinate?.mostCompletedStep
      },
      update: (data) => data.flowCoordinate,
    },
  },
}
</script>

<style scoped>
.flow-heading {
  @apply tw-hidden;
  @apply md:tw-block;
}
</style>
